// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"355e02cd","147":"0178a936","594":"8e62c6f1","887":"b06dffa0"}[chunkId] + ".chunk.css";
};